__webpack_require__.p = "https://kiszuriwalilibori.github.io/books/";